import { Box, Typography } from '@mui/material';

import { useDiagramEditorContext } from '../../contexts/diagramEditor.context';
import { useDiagramEditorLock } from '../../hooks/useDiagramEditorLock';
import { DiagramBuilding } from './DiagramBuilding';
import { DiagramEditor } from './DiagramEditor';

/**
 * Shows the diagram canvas, or the loading, building, or empty state when the
 * diagram cannot be edited yet.
 */
export function DiagramEditorCanvas() {
  const editor = useDiagramEditorContext();
  const { artifactID, diagram, isGenerating } = editor;
  const lock = useDiagramEditorLock();

  // A new diagram has no artifact until the backend begins to generate it.
  // While the chat answers, show that the diagram is building.
  if (!artifactID) {
    if (lock === 'generating') {
      return (
        <Box flex={1} position="relative">
          <DiagramBuilding />
        </Box>
      );
    }
    return (
      <Typography variant="body-m" p={2}>
        Describe the diagram in the chat to create it.
      </Typography>
    );
  }
  if (!diagram) {
    if (!editor.loading) return null;
    return (
      <Typography variant="body-m" role="status" p={2}>
        Loading diagram…
      </Typography>
    );
  }
  if (isGenerating && !diagram.content.nodes.length) {
    return (
      <Box flex={1} position="relative">
        <DiagramBuilding />
      </Box>
    );
  }
  return (
    <DiagramEditor
      diagram={diagram}
      locked={lock !== null}
      onChange={editor.update}
      history={editor.history}
    />
  );
}
